import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {};
const qs = {
  play: 'data-video-play',
  source: 'data-video-source',
  iframe: 'data-iframe',
}
const qsAll = {
  components: 'data-video-component',
}

const getVideoContent = (component) => {
  let videoHtml = ''
  const videoSource = JSON.parse(component.querySelector(`[${qs.source}]`).innerHTML)
  videoHtml += `<video class="w-full h-auto" autoplay controls loop>`
  videoSource.sources.forEach((source) => videoHtml += `<source src="${source.url}" type="${source.mime_type}">`)
  videoHtml += `</video>`
  return videoHtml
}

const initVideo = (component) => {
  component.querySelector(`[${qs.play}]`).addEventListener('click', () => {
    if(component.querySelector(`[${qs.source}]`))
      window.openCustomModal(getVideoContent(component))
    else
      window.openCustomModal(null, component.querySelector(`[${qs.iframe}]`).content.cloneNode(true))
  })
}

export const setupVideos = () => {
  cacheDom(dom, qs, qsAll)
  
  dom.components.forEach(component => initVideo(component))
}